import React from 'react';
import { Box } from '@mui/material';
import Location from './Location';

const LocationSettings = ({ defaultSettings, fetchSettings }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.location && (
        <Location
          settings={defaultSettings.location}
          fetchSettings={fetchSettings}
        />
      )}
    </Box>
  );
};

export default LocationSettings;
